import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import Proptypes from 'prop-types';
import fr from 'facet-rest';
import {
  DialogActions, DialogContent, DialogImage,
} from 'Views/Page/Content/Modal/Components';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { HeadlineText } from 'Packages/FacetDesign/Components/HeadLineText';
import { noop } from 'Helpers/PropTypes';
import { dataAttrs } from 'Helpers/Testing';

/**
 * This modal layout wrapper is meant to be used for PX modal layouts that have an (optional) image, a title, some
 * informational text, and a single picklist type question
 */
const PXPicklistQuestionModalWrapper = ({ children, buttonLabel, onSubmitSuccess }) => {
  const { onSubmit, saving, resource } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  const handleContinue = async () => {
    onSubmitSuccess(await onSubmit());
  };

  return (
    <>
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction={'column'} spacing={2} padding={2}>
          <DialogImage value={resource} />
          <HeadlineText size={'sm'} value={resource.attr('title')} {...dataAttrs('dialog-title', resource)} />
          {children}
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              {...dataAttrs('back-btn', resource)}
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        {resource.meta().canPost() ? <FDPrimaryActionButton
          label={buttonLabel}
          onClick={handleContinue}
          loading={saving}
          {...dataAttrs('continue-btn', resource)}
        />
          : null}
      </DialogActions>
    </>
  );
};

PXPicklistQuestionModalWrapper.defaultProps = {
  onSubmitSuccess: noop,
  buttonLabel: 'Continue →',
};

PXPicklistQuestionModalWrapper.propTypes = {
  onSubmitSuccess: Proptypes.func,
  children: Proptypes.any.isRequired,
  buttonLabel: Proptypes.string,
};

export default PXPicklistQuestionModalWrapper;
